import O1HD, {managers, modules, services} from "../../engines/gameEngine";
import ComeInOutItem from "./prefab/comeInOutItem";
import TalkMessageItem from "./prefab/talkMessageItem";
import {$WS} from "../../WsSdk/webSocketProtocol/webSocketProtoHead";
import {GameClient} from "../../engines/managers/gameSocketManager";
import CSubMatchRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/CSubMatchRoom";
import SSubMatchRoom from "../../WsSdk/webSocketProtocol/wsInstanceList/SSubMatchRoom";
// import CSubPeopleCome from "../../WsSdk/webSocketProtocol/talkRoomList/CSubPeopleCome";
// import SSubPeopleCome from "../../WsSdk/webSocketProtocol/talkRoomList/SSubPeopleCome";
// import SSubPeopleCount from "../../WsSdk/webSocketProtocol/talkRoomList/SSubPeopleCount";
// import SSubPeopleLearn from "../../WsSdk/webSocketProtocol/talkRoomList/SSubPeopleLearn";
// import CSubPeopleLearn from "../../WsSdk/webSocketProtocol/talkRoomList/CSubPeopleLearn";
// import CSubPeopleTalkMsg from "../../WsSdk/webSocketProtocol/talkRoomList/CSubPeopleTalkMsg";
// import SSubPeopleTalkMsg, {TalkMsgBody} from "../../WsSdk/webSocketProtocol/talkRoomList/SSubPeopleTalkMsg";
// import SSubPeopleTalkHistory from "../../WsSdk/webSocketProtocol/talkRoomList/SSubPeopleTalkHistory";
import {textFilter} from "../../scenes/test/filterWord";
// import CSubTalkRoomList from "../../WsSdk/webSocketProtocol/talkRoomList/CSubTalkRoomList";
// import SSubTalkRoomList from "../../WsSdk/webSocketProtocol/talkRoomList/SSubTalkRoomList";
// import CSubCreatRoom from "../../WsSdk/webSocketProtocol/talkRoomList/CSubCreatRoom";
import CSubLoginGame from "../../WsSdk/webSocketProtocol/wsInstanceList/CSubLoginGame";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TalkRoomMode extends cc.Component /*implements GameClient*/ {
    sendHallMessage: (cMsg?: $WS.WebSocketProtoHeadBody) => void;
    // sendGameMessage: (cMsg: $WS.WebSocketProtoHeadBody) => void;

    // readonly gameId: string = 'imDemo';
    readonly gameName: string = '聊天服务器';

    m_roomId: number;
    m_roomName: string;
    m_meCreatRmId: number;

    @property(cc.ScrollView)
    sv: cc.ScrollView = null;
    @property(cc.Node)
    ndContentList: cc.Node = null;
    @property(cc.Prefab)
    pbComeInOut: cc.Prefab = null;
    @property(cc.Node)
    ndLoginLayer: cc.Node = null;
    @property(cc.Node)
    ndTalkLayer: cc.Node = null;
    @property(cc.Node)
    ndRoomListLayer: cc.Node = null;
    @property(cc.EditBox)
    editBox: cc.EditBox = null;
    @property(cc.Prefab)
    pbLeftTalkMessage: cc.Prefab = null;
    @property(cc.Prefab)
    pbRightTalkMessage: cc.Prefab = null;
    @property(cc.EditBox)
    editTalkMessage: cc.EditBox = null;
    @property(cc.Label)
    lbPeopleCount: cc.Label = null;
    @property(cc.Node)
    ndRoomListContent: cc.Node = null;
    @property(cc.Prefab)
    pbRoomOne: cc.Prefab = null;
    @property(cc.Node)
    ndRoomCreator: cc.Node = null;
    @property(cc.EditBox)
    edTitleCt: cc.EditBox = null;
    @property(cc.EditBox)
    edExplainCt: cc.EditBox = null;
    // @property(cc.Node)
    // ndBtCreateRoom: cc.Node = null;
    @property(cc.Label)
    lbBtCreatRoom: cc.Label = null;


    onLoad() {
        // managers().socketMgr.registerGameClient(this);
    }

    start() {
        //
        this.ndLoginLayer.active = false;
        this.ndTalkLayer.active = false;
        this.ndRoomListLayer.active = false;
        this.ndRoomCreator.active = false;
        this.lbPeopleCount.string = '来将可留姓名';
        //
        this.loadNickName();
        //
        if (this.m_nickName) {
            this.onBtnLogin();
        } else {
            this.ndLoginLayer.active = true;
        }
    }

    private loadNickName() {
        this.m_nickName = O1HD.getServices().localStorageSrv.getStorage(this.m_NAME_KEY);
    }

    private writeNickName() {
        O1HD.getServices().localStorageSrv.setStorage(this.m_NAME_KEY, this.m_nickName);
    }

    //成员变量
    private m_NAME_KEY: string = 'talk-nick-name';
    private m_nickName: string = null;

    onBtnSendMessage() {
        let str = this.editTalkMessage.string;
        if (str.trim() == '') {
            O1HD.getModules().uiControlModule.showMessageBox('请输入有效消息');
            return;
        }
        str = textFilter(str);
        // const msg = new CSubPeopleTalkMsg(str);
        // managers().socketMgr.sendGameMessage(this.gameId, msg);
        // this.editTalkMessage.string = '';
    }

    onBtnLogin() {
        let name = this.m_nickName || this.editBox.string;
        if (name.trim() == '') {
            O1HD.getModules().uiControlModule.showMessageBox('请输入正确的昵称');
            return;
        }
        //名字记录本地
        if (name != this.m_nickName) {
            this.m_nickName = name;
            this.writeNickName();
        }
        //
        O1HD.getModules().uiControlModule.showLoading(null, '连接聊天室').then(() => {
            // const msg = new CSubTalkRoomList();
            // managers().socketMgr.sendGameMessage(this.gameId, msg);
            // const msg = new CSubMatchRoom();
            // managers().socketMgr.sendGameMessage(this.gameId, msg);
        });
    }

    onBtnExit() {
        // const cMsg = new CSubPeopleLearn();
        // managers().socketMgr.sendGameMessage(this.gameId, cMsg);
        modules().uiControlModule.showLoading(null, '正在退出聊天室……').then();
        // O1HD.getModules().gameWebsocketModule.sendMessage(
        //     messageConf.packageMessage(messageConf.MESSAGE_HEAD.OUT, this.m_nickName)
        // );
    }

    private onComeIn(rm: SSubMatchRoom) {
        this.m_roomId = rm.body.roomId;
        this.m_roomName = rm.body.roomName;
        this.ndRoomCreator.active = false;
        this.ndRoomListLayer.active = false;
        this.ndTalkLayer.active = true;
        // const msg = new CSubPeopleCome(this.m_nickName);
        // managers().socketMgr.sendGameMessage(this.gameId, msg);
    }

    private onNetTalkMessage(data: string) {
        console.log('有人讲话', data);
        // const sMsg = SSubPeopleTalkMsg.unPackageMessage(data);
        // const res = sMsg.body;
        // this.onAddTalkMessage(res);
    }

    // protected onAddTalkMessage(res: TalkMsgBody) {
    //     //
    //     let pb = this.pbLeftTalkMessage;
    //     if (res.name == this.m_nickName) {
    //         pb = this.pbRightTalkMessage;
    //     }
    //     let node = cc.instantiate(pb);
    //     this.ndContentList.addChild(node);
    //     node.getComponent(TalkMessageItem).setMessageText(res.text, res.name, res.time);
    //     //
    //     if (!this.sv.isScrolling()) {
    //         this.sv.scrollToBottom(0.5);
    //     }
    // }

    // protected onRoomListRes(res: SSubTalkRoomList) {
    //     this.ndRoomListContent.destroyAllChildren();
    //     this.ndRoomListLayer.active = true;
    //     res.body.list.sort((a, b) => {
    //         const meUid = managers().socketMgr.getUserId();
    //         let aW = 0;
    //         let bW = 0;
    //         if (a.creatorUid == meUid) {
    //             aW += 10000;
    //         }
    //         if (b.creatorUid == meUid) {
    //             bW += 10000;
    //         }
    //         aW += a.rmCount;
    //         bW += b.rmCount;
    //         //
    //         return aW - bW;
    //     });
    //     this.scheduleOnce(() => {
    //         // this.ndBtCreateRoom.active = true;
    //         this.lbBtCreatRoom.string = '创建聊天室';
    //         res.body.list.forEach(rm => {
    //             const meUid = managers().socketMgr.getUserId();
    //             if (rm.creatorUid == meUid) {
    //                 // this.ndBtCreateRoom.active = false;
    //                 this.lbBtCreatRoom.string = '我的聊天室';
    //                 this.m_meCreatRmId = rm.rmId;
    //             }
    //
    //             const node = cc.instantiate(this.pbRoomOne);
    //             this.ndRoomListContent.addChild(node);
    //             cc.find('bg/lbTitle', node).getComponent(cc.Label).string = `${rm.rmTitle}(${rm.rmCount})`;
    //             cc.find('bg/lbCreator', node).getComponent(cc.Label).string = `创建人:${rm.rmCreator}${
    //                 rm.creatorUid == meUid ? '[我]' : ''
    //             }`;
    //             cc.find('bg/lbExplain', node).getComponent(cc.Label).string = rm.rmExplain;
    //             const rid = rm.rmId;
    //
    //             node.on('click', () => {
    //                 modules().uiControlModule.showLoading(null, '正在进入房间').then(() => {
    //                     const cMsg = new CSubMatchRoom('匿名', rid);
    //                     managers().socketMgr.sendGameMessage(this.gameId, cMsg);
    //                 })
    //             });
    //         });
    //         modules().uiControlModule.hideLoading();
    //     });
    // }

    private onNetComeInOut(userName: string, isIn: boolean) {
        //
        O1HD.getModules().uiControlModule.hideLoading();
        //
        this.ndLoginLayer.active = false;
        this.ndRoomListLayer.active = false;
        this.ndTalkLayer.active = true;
        //
        let node = cc.instantiate(this.pbComeInOut);
        this.ndContentList.addChild(node);
        node.getComponent(ComeInOutItem).setText(`${userName}${isIn ? '进入聊天室' : '离开了聊天室'}`);
    }

    private onNetPeopleChange(data) {
        this.lbPeopleCount.string = `${this.m_roomName} (${data})`;
    }

    protected onBtnCreateRoom() {
        if (this.m_meCreatRmId) {
            modules().uiControlModule.showLoading(null, '正在进入房间').then(() => {
                const cMsg = new CSubMatchRoom('匿名',this.m_meCreatRmId);
                // managers().socketMgr.sendGameMessage(this.gameId, cMsg);
            })
        } else {
            this.ndRoomCreator.active = true;
        }
    }

    protected onBtnCancelCreateRoom() {
        this.ndRoomCreator.active = false;
    }

    protected onBtnResetRoomList() {
        modules().uiControlModule.showLoading(null, '刷新中').then(() => {
            // const cMsg = new CSubTalkRoomList();
            // managers().socketMgr.sendGameMessage(this.gameId, cMsg);
        });
    }

    protected onBtnHelp() {
        modules().uiControlModule.showMessageBox('只能创建一个聊天室，暂不支持删除和更改信息');
    }

    protected onBtnSubmitCreate() {
        const st = this.edTitleCt.string;
        const et = this.edExplainCt.string;
        if (st.trim().length <= 0) {
            modules().uiControlModule.showMessageBox('请输入标题');
            return;
        }
        if (et.trim().length <= 0) {
            modules().uiControlModule.showMessageBox('请输入说明');
            return;
        }
        modules().uiControlModule.showLoading(null, '正在创建并进入聊天室').then();
        // const cMsg = new CSubCreatRoom(st, et);
        // managers().socketMgr.sendGameMessage(this.gameId, cMsg);
    }

    // async onGameMessage(head: string, body: string): Promise<void> {
    //     switch (head) {
    //         case SSubMatchRoom.HEAD: {
    //             //发送加入房间
    //             const match = SSubMatchRoom.unPackageMessage(body);
    //             this.onComeIn(match);
    //             break;
    //         }
    //         case SSubPeopleCome.HEAD: {
    //             const data = SSubPeopleCome.unPackageMessage(body);
    //             this.onNetComeInOut(data.body.userName, true);
    //             modules().uiControlModule.hideLoading();
    //             break;
    //         }
    //         case SSubPeopleCount.HEAD: {
    //             const data = SSubPeopleCount.unPackageMessage(body);
    //             this.onNetPeopleChange(data.body.count);
    //             break;
    //         }
    //         case SSubPeopleLearn.HEAD: {
    //             const data = SSubPeopleLearn.unPackageMessage(body);
    //             if (data.body.isMe) {
    //                 this.ndContentList.destroyAllChildren();
    //                 this.ndTalkLayer.active = false;
    //                 const cMsg = new CSubTalkRoomList();
    //                 managers().socketMgr.sendGameMessage(this.gameId, cMsg);
    //                 // managers().gameMgr.returnMainScene().then();
    //             } else {
    //                 this.onNetComeInOut(data.body.userName, false);
    //             }
    //             break;
    //         }
    //         case SSubPeopleTalkMsg.HEAD: {
    //             this.onNetTalkMessage(body);
    //             break;
    //         }
    //         case SSubPeopleTalkHistory.HEAD: {
    //             const sMsg = SSubPeopleTalkHistory.unPackageMessage(body);
    //             sMsg.body.list.forEach(msg => {
    //                 this.onAddTalkMessage(msg);
    //             });
    //             break;
    //         }
    //         case SSubTalkRoomList.HEAD: {
    //             const sMsg = SSubTalkRoomList.unPackageMessage(body);
    //             this.onRoomListRes(sMsg);
    //             break;
    //         }
    //         default: {
    //             console.error('#1562011 未知消息');
    //             break;
    //         }
    //     }
    //     return Promise.resolve();
    // }

    protected onDestroy() {
        console.warn('清除游戏');
        managers().socketMgr.destroyCurrGameClient();
    }

    // update (dt) {}
}
